export default {
  "pl": {
    "notification": {
      "actions": {
        "delete": "Usuń powiadomienie",
        "deleteAll": "Usuń wszystkie",
        "markAllAsRead": "Oznacz wszystkie jako przeczytane",
        "mark_as_read": "Oznacz jako przeczytane",
        "mark_as_unread": "Oznacz jako nieprzeczytane"
      },
      "customers": {
        "announcement": {
          "create": "utworzył(a) post z aktualnościami. | utworzył(a) następującą liczbę postów z aktualnościami: {group_notification_count}. | | utworzył(a) następującą liczbę postów z aktualnościami: {group_notification_count}."
        },
        "decision": {
          "message": {
            "create": "wysłał(a) nową wiadomość w rozmowie <i>{group_name}</i>. | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}. | | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}."
          },
          "published": {
            "customer": "dodał(a) decyzję: <i>{notifiable_name}</i>."
          }
        },
        "decision_document": {
          "create": "przesłał(a) dokument <i>{notifiable_name}</i> związany z decyzją <i>{group_name}</i>. | przesłał(a) następującą liczbę dokumentów związanych z decyzją <i>{group_name}</i>: {group_notification_count}. | | przesłał(a) następującą liczbę dokumentów związanych z decyzją <i>{group_name}</i>: {group_notification_count}."
        },
        "decision_proposal": {
          "approved": "zatwierdzona propozycja <i>'{notifiable_name}'</i> w decyzji <i>'{group_name}'</i>. | zatwierdzona {group_notification_count} propozycja w decyzji <i>'{group_name}' </i>. | zatwierdził {group_notification_count} propozycje w decyzji <i>'{group_name}'</i>.",
          "create": "utworzono propozycję <i>'{notifiable_name}'</i> w decyzji <i>'{group_name}'</i>. | utworzono {group_notification_count} propozycji w decyzji <i>'{group_name}' </i>. | utworzył {group_notification_count} propozycji w decyzji <i>'{group_name}'</i>.",
          "edit_approved": "edytował zatwierdzoną propozycję <i>'{notifiable_name}'</i> w decyzji <i>'{group_name}'</i>. | edytował {group_notification_count} zatwierdzony wniosek w decyzji <i>'{ group_name}'</i>. | edytowali {group_notification_count} zatwierdzone propozycje w decyzji <i>'{group_name}'</i>.",
          "relaunched": "Ponownie udostępnił odrzuconą propozycję <i>'{notifiable_name}'</i> | Ponownie udostępnił {group_notification_count} odrzuconych propozycji w decyzji <i>'{group_name}'</i> | | Ponownie udostępnił {group_notification_count} odrzuconych propozycji w decyzji <i>'{group_name}'</i>"
        },
        "document": {
          "create": "przesłał(a) dokument <i>{notifiable_name}</i>. | przesłał(a) następującą liczbę dokumentów: {group_notification_count}. | | przesłał(a) następującą liczbę dokumentów: {group_notification_count}.",
          "invoice": {
            "create": "przesłał(a) fakturę <i>{notifiable_name}</i>. | przesłał(a) następującą liczbę faktur: {group_notification_count}. | | przesłał(a) następującą liczbę faktur: {group_notification_count}."
          },
          "proposal": {
            "create": "dodał(a) dokument <i>{notifiable_name}</i> związany z ofertą <i>{group_name}</i>. | dodał(a) następującą liczbę dokumentów związanych z ofertą <i>{group_name}</i>: {group_notification_count}. | | dodał(a) następującą liczbę dokumentów związanych z ofertą <i>{group_name}</i>: {group_notification_count}."
          }
        },
        "export": {
          "create": "Twoje dane do eksportu są gotowe do pobrania."
        },
        "installment": {
          "published": "udostępnił ratę <i>'{notifiable_name}'</i>. | udostępnił {group_notification_count} rat. | udostępnił {group_notification_count} rat.",
          "status": {
            "changed": "zmienił status raty <i>'{notifiable_name}'</i> na <i>'{status}'</i>. | zmieniono stan rat {group_notification_count}. | zmienił stan rat {group_notification_count}."
          }
        },
        "issue": {
          "create": "stworzył problem <i>'%{notifiable_name}'</i> | utworzył {group_notification_count} problemy dla <i>'{group_name}'</i> | | utworzył {group_notification_count} problemy dla <i>'{group_name}'</i>",
          "status": {
            "update": "zaktualizował status <i>'%{notifiable_name}'</i> na <i>'%{status}'</i>. | zaktualizował stan {group_notification_count} problemów. | | zaktualizował stan {group_notification_count} problemów."
          }
        },
        "question": {
          "create": "utworzył(a) pytanie <i>{notifiable_name}</i> w FAQ <i>{group_name}</i>. | utworzył(a) następującą liczbę pytań w FAQ <i>{group_name}</i>: {group_notification_count}. | | utworzył(a) następującą liczbę pytań w FAQ <i>{group_name}</i>: {group_notification_count}."
        },
        "reminder": {
          "due": "Nie zapomnij o podjęciu decyzji w sprawie: <i>{notifiable_name}</i>."
        },
        "survey": {
          "published": "prosi o twoją opinię w sprawie: <i>{group_name}</i>."
        },
        "ticket": {
          "create": "zainicjował(a) rozmowę: <i>{notifiable_name}</i>.",
          "message": {
            "create": "wysłał(a) nową wiadomość w rozmowie <i>{group_name}</i>. | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}. | | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}.",
            "move": "przeniesiono Twoją wiadomość do rozmowy <i>'{group_name}'</i>"
          }
        },
        "ticket_document": {
          "create": "przesłany dokument <i>'{notifiable_name}'</i> w rozmowie <i>'{group_name}'</i>. | przesłał {group_notification_count} dokumenty w rozmowie <i>'{group_name}'</i>. | | przesłał {group_notification_count} dokumenty w rozmowie <i>'{group_name}'</i>."
        }
      },
      "employees": {
        "announcement": {
          "create": "utworzył(a) post z aktualnościami. | utworzył(a) następującą liczbę postów z aktualnościami w lokalizacji <i>{group_name}</i>: {group_notification_count} | | utworzył(a) następującą liczbę postów z aktualnościami w lokalizacji <i>{group_name}</i>: {group_notification_count}."
        },
        "decision": {
          "message": {
            "create": "wysłał(a) nową wiadomość w rozmowie <i>{group_name}</i>. | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}. | | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}."
          },
          "responsible": {
            "update": "uczynił Cię nowym odpowiedzialnym za decyzję <i>'{notifiable_name}'</i>"
          }
        },
        "decision_document": {
          "create": "przesłał(a) dokument <i>{notifiable_name}</i> związany z decyzją <i>{group_name}</i>. | przesłał(a) następującą liczbę dokumentów związanych z decyzją <i>{group_name}</i>: {group_notification_count}. | | przesłał(a) następującą liczbę dokumentów związanych z decyzją <i>{group_name}</i>: {group_notification_count}."
        },
        "decision_proposal": {
          "approved": "zaakceptował(a) ofertę <i>{notifiable_name}</i> związaną z decyzją <i>{group_name}</i>. | zaakceptował(a) następującą liczbę ofert związanych z decyzją <i>{group_name}</i>: {group_notification_count}. | | zaakceptował(a) następującą liczbę ofert związanych z decyzją <i>{group_name}</i>: {group_notification_count}.",
          "create": "utworzył(a) ofertę <i>{notifiable_name}</i> związaną z decyzją <i>{group_name}</i>. | utworzył(a) następującą liczbę ofert związanych z decyzją <i>{group_name}</i>: {group_notification_count}. | | utworzył(a) następującą liczbę ofert związanych z decyzją <i>{group_name}</i>: {group_notification_count}.",
          "requested_changes": "odrzucił propozycję <i>'{notifiable_name}'</i> w decyzji <i>'{group_name}'</i>. | odrzucił {group_notification_count} propozycje w decyzji <i>'{group_name}'</i>. | | odrzucił {group_notification_count} propozycje w decyzji <i>'{group_name}'</i>.",
          "signed": "Wszyscy sygnatariusze, których zażądano, podpisali dokumenty wniosku <i>„{notifiable_name}”</i>."
        },
        "document": {
          "create": "przesłał(a) dokument <i>{notifiable_name}</i> do katalogu <i>{group_name}</i>. | przesłał(a) następującą liczbę dokumentów do katalogu <i>{group_name}</i>: {group_notification_count}. | | przesłał(a) następującą liczbę dokumentów do katalogu <i>{group_name}</i>: {group_notification_count}.",
          "proposal": {
            "create": "dodał(a) dokument <i>{notifiable_name}</i> związany z ofertą <i>{group_name}</i>. | dodał(a) następującą liczbę dokumentów związanych z ofertą <i>{group_name}</i>: {group_notification_count}. | | dodał(a) następującą liczbę dokumentów związanych z ofertą <i>{group_name}</i>: {group_notification_count}."
          }
        },
        "export": {
          "create": "Twoje dane do eksportu są gotowe do pobrania."
        },
        "question": {
          "create": "utworzył(a) pytanie <i>{notifiable_name}</i> w FAQ <i>{group_name}</i>. | utworzył(a) następującą liczbę pytań w FAQ <i>{group_name}</i>: {group_notification_count}. | | utworzył(a) następującą liczbę pytań w FAQ <i>{group_name}</i>: {group_notification_count}."
        },
        "survey_answer": {
          "create": "odpowiedział(a) w: <i>{group_name}</i>."
        },
        "ticket": {
          "create": "zainicjował(a) rozmowę: <i>{notifiable_name}</i>.",
          "mention": {
            "create": "wspomniał o Tobie w rozmowie <i>'{group_name}'</i>. | wspomniał o Tobie w {group_notification_count} wiadomościach w rozmowie <i>'{group_name}'</i>. | | wspomniał o Tobie w {group_notification_count} wiadomościach w rozmowie <i>'{group_name}'</i>."
          },
          "message": {
            "create": "wysłał(a) nową wiadomość w rozmowie <i>{group_name}</i>. | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}. | | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}."
          },
          "responsible": {
            "update": "przypisał(a) do ciebie rozmowę: <i>{notifiable_name}</i>."
          }
        },
        "ticket_document": {
          "create": "przesłany dokument <i>'{notifiable_name}'</i> w rozmowie <i>'{group_name}'</i>. | przesłał {group_notification_count} dokumenty w rozmowie <i>'{group_name}'</i>. | | przesłał {group_notification_count} dokumenty w rozmowie <i>'{group_name}'</i>."
        },
        "todo": {
          "assign": "przypisał(a) do ciebie zadanie <i>{notifiable_name}</i>. | przypisał(a) do ciebie następującą liczbę zadań: {group_notification_count}. | przypisał(a) do ciebie zadanie <i>{notifiable_name}</i>. | przypisał(a) do ciebie następującą liczbę zadań: {group_notification_count}."
        }
      },
      "labels": {
        "all": "Wszystkie projekty",
        "allDecisions": "Wszystkie decyzje",
        "allStatuses": "Wszystkie",
        "filter": "Filtruj",
        "noNewNotification": "Jesteś na bieżąco!",
        "noResults": "Brak wyników. Spróbuj czegoś innego!",
        "none": "Nie masz w tej chwili żadnych powiadomień.",
        "notification_level_name_asc": "Jednostka A->Z",
        "notification_level_name_desc": "Jednostka Z->A",
        "sort": "Sortować",
        "status": "Status",
        "unreadOnly": "Tylko nieprzeczytane",
        "updated_at_asc": "Najpierw najstarsi",
        "updated_at_desc": "Najnowszy pierwszy"
      },
      "other_user": "i 1 inny,",
      "other_users": "i 1 inny | i jeszcze {count}",
      "partners": {
        "decision": {
          "message": {
            "create": "wysłał(a) nową wiadomość w rozmowie <i>{group_name}</i>. | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}. | | wysłał(a) następującą liczbę nowych wiadomości w rozmowie <i>{group_name}</i>: {group_notification_count}."
          },
          "published": {
            "partners": "zainicjował(a) decyzję <i>{notifiable_name}</i>. | zainicjował(a) następującą liczbę decyzji <i>{group_name}</i>: {group_notification_count}. | | zainicjował(a) następującą liczbę decyzji <i>{group_name}</i>: {group_notification_count}."
          }
        },
        "decision_document": {
          "create": "przesłał(a) dokument <i>{notifiable_name}</i> związany z decyzją <i>{group_name}</i>. | przesłał(a) następującą liczbę dokumentów związanych z decyzją <i>{group_name}</i>: {group_notification_count}. | | przesłał(a) następującą liczbę dokumentów związanych z decyzją <i>{group_name}</i>: {group_notification_count}."
        },
        "decision_proposal": {
          "approved": "zaakceptował(a) ofertę <i>{notifiable_name}</i> związaną z decyzją: <i>{group_name}</i>. | zaakceptował(a) ofertę <i>{notifiable_name}</i> związaną z decyzją: <i>{group_name}</i>. | | zaakceptował(a) ofertę związaną z decyzją: <i>{group_name}</i>. | zaakceptował(a) oferty związane z decyzją: <i>{group_name}</i>.",
          "create": "utworzył(a) ofertę <i>{notifiable_name}</i> związaną z decyzją <i>{group_name}</i>. | utworzył(a) następującą liczbę ofert związanych z decyzją <i>{group_name}</i>: {group_notification_count}. | | utworzył(a) następującą liczbę ofert związanych z decyzją <i>{group_name}</i>: {group_notification_count}.",
          "requested_changes": "odrzucił propozycję <i>'{notifiable_name}'</i> w decyzji <i>'{group_name}'</i>. | odrzucił {group_notification_count} propozycje w decyzji <i>'{group_name}'</i>. | | odrzucił {group_notification_count} propozycje w decyzji <i>'{group_name}'</i>."
        },
        "document": {
          "proposal": {
            "create": "dodał(a) dokument <i>{notifiable_name}</i> związany z ofertą <i>{group_name}</i>. | dodał(a) następującą liczbę dokumentów związanych z ofertą <i>{group_name}</i>: {group_notification_count}. | | dodał(a) następującą liczbę dokumentów związanych z ofertą <i>{group_name}</i>: {group_notification_count}."
          }
        },
        "export": {
          "create": "Twoje dane eksportu są gotowe do pobrania."
        },
        "issue": {
          "status": {
            "update": "zaktualizował status problemu w <i>'%{group_name}'</i>. | zaktualizowało status {group_notification_count} problemu w <i>'%{group_name}'</i>. | | zaktualizowało status {group_notification_count} problemu w <i>'%{group_name}'</i>."
          }
        },
        "issue_list": {
          "published": "opublikował listę problemów <i>'%{notifiable_name}'</i> | opublikował listę problemów <i>'%{notifiable_name}'</i> dla {group_notification_count} jednostek | | opublikował listę problemów <i>'%{notifiable_name}'</i> dla {group_notification_count} jednostek"
        },
        "reminder": {
          "due": "Decyzja <i>{notifiable_name}</i> nie została podjęta w przypadku jednostki: {level_name}."
        },
        "unit": {
          "visibled": "dodał(a) klienta <i>{customer_group_name}</i> do <i>{group_name}</i> dla jednostki: <i>{notifiable_name}</i>."
        }
      },
      "title": "Powiadomienia"
    }
  }
}
